import React from 'react';
import { AuthProvider, useAuth } from './context/AuthContext';
import { NavigationProvider, useNavigation } from './context/NavigationContext';
import Login from './pages/Login';
import Inbound from './pages/Inbound';
import Appointments from './pages/Appointments';
import OrderOps from './pages/OrderOps';
import InventoryBrowser from './pages/InventoryBrowser';
import ItemHistory from './pages/ItemHistory';
import InTransit from './pages/InTransit';
import PastOrders from './pages/PastOrders';
import BrandOps from './pages/BrandOps';
import AdTracker from './pages/AdTracker';
import MessagingHub from './pages/MessagingHub';
import PackerApp from './pages/PackerApp';
import MarketerApp from './pages/MarketerApp';
import MobilePackApp from './pages/MobilePackApp';
import DummyPackApp from './pages/DummyPackApp';
import Sale from './pages/Sale';
import RiderAssignment from './pages/RiderAssignment';
import RiderApproval from './pages/RiderApproval';
import SkipzyAppSettings from './pages/SkipzyAppSettings';
import Lookup from './pages/Lookup';
import CRM from './pages/CRM';
import PullScrape from './pages/catalogue/PullScrape';
import FullCatalogue from './pages/catalogue/FullCatalogue';
import CatalogueImages from './pages/catalogue/Images';
import CatalogueAttributes from './pages/catalogue/Attributes';
// Catalogue -> Search (staff tool to try the website search) is hidden for now; uncomment here and in navConfig.js.
// import CatalogueSearch from './pages/catalogue/Search';
import AppShell from './shell/AppShell';

function AppInner() {
  const { auth }        = useAuth();
  const { currentPage } = useNavigation();
  // /dummy = a blue-themed, read-only packing sandbox (client-side simulation,
  // never writes to the DB). Applies .dummy-theme (green -> blue) to everything.
  const isDummy = typeof window !== 'undefined' && window.location.pathname.startsWith('/dummy');
  if (isDummy) {
    return (
      <div className="dummy-theme">
        {!auth ? <Login /> : <DummyPackApp />}
      </div>
    );
  }
  if (!auth) return <Login />;
  // Packers get a fully restricted, self-contained view — no ZOCS nav or pages.
  if (auth.access_level === 'packer') return <PackerApp />;
  // Marketers (Skipzy Representatives) get only the read-only rep dashboard.
  if (auth.access_level === 'marketer') return <MarketerApp />;
  // Mobile packers get only the phone-friendly packing app.
  if (auth.access_level === 'mobile_packer') return <MobilePackApp />;
  const isAdmin     = auth.access_level === 'admin';
  const isCoreTeam  = isAdmin || auth.access_level === 'core_team';
  return (
    <AppShell>
      {currentPage === 'inbound'      && <Inbound />}
      {currentPage === 'appointments' && <Appointments />}
      {currentPage === 'orderops'     && <OrderOps />}
      {currentPage === 'intransit'    && <InTransit />}
      {currentPage === 'riderassign'  && isCoreTeam && <RiderAssignment />}
      {currentPage === 'riderapproval' && isAdmin && <RiderApproval />}
      {currentPage === 'SkipzyAppSettings' && isAdmin && <SkipzyAppSettings />}
      {currentPage === 'pastorders'   && isAdmin && <PastOrders />}
      {currentPage === 'inventory'    && <InventoryBrowser />}
      {currentPage === 'itemhistory'  && <ItemHistory />}
      {currentPage === 'brandops'     && isCoreTeam && <BrandOps />}
      {currentPage === 'adtracker'    && isAdmin && <AdTracker />}
      {currentPage === 'messaging'    && isAdmin && <MessagingHub />}
      {currentPage === 'sale'         && isAdmin && <Sale />}
      {currentPage === 'lookup'       && isAdmin && <Lookup />}
      {currentPage === 'crm'          && isAdmin && <CRM />}
      {currentPage === 'cataloguepull'       && isCoreTeam && <PullScrape />}
      {currentPage === 'catalogueimages'     && isCoreTeam && <CatalogueImages />}
      {currentPage === 'catalogueattributes' && isCoreTeam && <CatalogueAttributes />}
      {currentPage === 'cataloguedata'       && isCoreTeam && <FullCatalogue />}
      {/* {currentPage === 'cataloguesearch'     && isCoreTeam && <CatalogueSearch />} */}
    </AppShell>
  );
}

export default function App() {
  return (
    <AuthProvider>
      <NavigationProvider>
        <AppInner />
      </NavigationProvider>
    </AuthProvider>
  );
}
